import { MockFactory } from '@tino-frontend/mocks'
import { BillSnoozeDetailsSnooze } from '@types'

export const SnoozeDetailsMock = new MockFactory<BillSnoozeDetailsSnooze>({
  total_value: 96000,
  minimum_payment: 14400,
  deferred_remaining_value: 81600,
  interest_percentage: 100,
  interest_value: 960,
  future_debt_value: 82660,
  bill_due_date: '2022-10-06T00:00:00Z',
  effectivation_date: '2022-11-05T00:00:00Z',
  financing_id: 'financingId-123',
})
